import { render, staticRenderFns } from "./StatisticsSection.vue?vue&type=template&id=4f406306&scoped=true"
import script from "./StatisticsSection.vue?vue&type=script&lang=js"
export * from "./StatisticsSection.vue?vue&type=script&lang=js"
import style0 from "./StatisticsSection.vue?vue&type=style&index=0&id=4f406306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f406306",
  null
  
)

export default component.exports